import React from 'react';

import './DemoBadge.scss';

export const DemoBadge: React.VFC = () => (
  <div className="demo-badge" title="回答は送信されません">
    DEMO
  </div>
);
